export default function getValue(obj, key) {
    let value = obj[key];
    return (typeof value !== 'undefined') ? value : obj.default;
}


// WEBPACK FOOTER //
// ./src/defaultValues/getValue.js